const DISPLAY = "APP/DISPLAY";

export const DISPLAY_FONTSIZE_DECREASE = `${DISPLAY}/FONTSIZE/DECREASE`;
export const DISPLAY_FONTSIZE_INCREASE = `${DISPLAY}/FONTSIZE/INCREASE`;
export const DISPLAY_IS_EDIT_SET = `${DISPLAY}/IS_EDIT/SET`;
export const DISPLAY_IS_ORIGIN_SET = `${DISPLAY}/IS_ORIGIN/SET`;
export const DISPLAY_LEFT_SIDE_WIDTH_SET = `${DISPLAY}/LEFT_SIDE_WIDTH/SET`;
export const DISPLAY_RIGHT_SIDE_WIDTH_SET = `${DISPLAY}/RIGHT_SIDE_WIDTH/SET`;
